var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        { attrs: { fluid: "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c("v-col", { attrs: { cols: "12", md: "1" } }, [
                                _c("strong", [_vm._v("Hotel")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "3" } },
                                [
                                  _c("ies-hotel-key-picker", {
                                    attrs: {
                                      field: _vm.reservation.hotel_key,
                                      configuration:
                                        '{"shouldEmitOnSelect":true, "selectEventName":"New Reservation: select hotel"}',
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "12", md: "1" } }, [
                                _c("strong", [_vm._v("Client")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "3" } },
                                [
                                  _c("v-text-field", {
                                    model: {
                                      value: _vm.reservation.member_key,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.reservation,
                                          "member_key",
                                          $$v
                                        )
                                      },
                                      expression: "reservation.member_key",
                                    },
                                  }),
                                  _vm._v("*"),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "12", md: "1" } }, [
                                _c("strong", [_vm._v("Status")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "3" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      label: "Enquiry/Reservation Status",
                                      items: _vm.statuses,
                                      autocomplete: "",
                                    },
                                    model: {
                                      value: _vm.reservation.status_key,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.reservation,
                                          "status_key",
                                          $$v
                                        )
                                      },
                                      expression: "reservation.status_key",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                                _c("strong", [_vm._v("Arriving")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "4" } },
                                [
                                  _c("v-date-picker", {
                                    staticClass: "no-print",
                                    attrs: { landscape: "" },
                                    model: {
                                      value: _vm.reservation.date_arrival,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.reservation,
                                          "date_arrival",
                                          $$v
                                        )
                                      },
                                      expression: "reservation.date_arrival",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                                _c("strong", [_vm._v("Leaving")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "4" } },
                                [
                                  _c("v-date-picker", {
                                    staticClass: "no-print",
                                    attrs: { landscape: "" },
                                    model: {
                                      value: _vm.reservation.date_departure,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.reservation,
                                          "date_departure",
                                          $$v
                                        )
                                      },
                                      expression: "reservation.date_departure",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                                _c("strong", [_vm._v("Stay Length")]),
                              ]),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "12", md: "10" } }, [
                                _vm._v(
                                  _vm._s(_vm.reservation.stay_length) +
                                    " " +
                                    _vm._s(
                                      _vm.reservation.stay_length === 1
                                        ? "Night"
                                        : "Nights"
                                    )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                                _c("strong", [_vm._v("Rooms")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "10" } },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _vm._l(
                                        _vm.reservation.units,
                                        function (unit, index) {
                                          return _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c(
                                                "fieldset",
                                                [
                                                  _c(
                                                    "v-card",
                                                    [
                                                      _c(
                                                        "v-card-text",
                                                        [
                                                          _c(
                                                            "v-layout",
                                                            {
                                                              attrs: {
                                                                wrap: "",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    md: "6",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-select",
                                                                    {
                                                                      attrs: {
                                                                        items:
                                                                          _vm.roomTypes,
                                                                        label:
                                                                          "Room Type",
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          unit.hotel_room_key,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              unit,
                                                                              "hotel_room_key",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "unit.hotel_room_key",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    md: "6",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-select",
                                                                    {
                                                                      attrs: {
                                                                        items:
                                                                          _vm.rateTypes,
                                                                        label:
                                                                          "Rate Type",
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          unit.rate_type_key,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              unit,
                                                                              "rate_type_key",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "unit.rate_type_key",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    md: "1",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                        Adults:\n                                                    "
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    md: "2",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-text-field",
                                                                    {
                                                                      model: {
                                                                        value:
                                                                          unit.occ_adults,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              unit,
                                                                              "occ_adults",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "unit.occ_adults",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    md: "1",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                        Old Children:\n                                                    "
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    md: "2",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-text-field",
                                                                    {
                                                                      model: {
                                                                        value:
                                                                          unit.occ_oldchildren,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              unit,
                                                                              "occ_oldchildren",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "unit.occ_oldchildren",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    md: "1",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                        Children:\n                                                    "
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    md: "2",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-text-field",
                                                                    {
                                                                      model: {
                                                                        value:
                                                                          unit.occ_children,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              unit,
                                                                              "occ_children",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "unit.occ_children",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    md: "1",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                        Babies:\n                                                    "
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    md: "2",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-text-field",
                                                                    {
                                                                      model: {
                                                                        value:
                                                                          unit.occ_babies,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              unit,
                                                                              "occ_babies",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "unit.occ_babies",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-btn",
                                                                    {
                                                                      staticClass:
                                                                        "ies-coral",
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.removeUnit(
                                                                              index
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-icon",
                                                                        [
                                                                          _vm._v(
                                                                            "delete"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " Delete"
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ies-green",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addBlankRoom()
                                                },
                                              },
                                            },
                                            [
                                              _c("v-icon", [_vm._v("add")]),
                                              _vm._v(" Add Room"),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                                _vm._v("Additional Fees"),
                              ]),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "12", md: "10" } }, [
                                _c("fieldset", [
                                  !_vm.hotel
                                    ? _c("div", [
                                        _vm._v(
                                          "Please choose a hotel to see the fees which apply"
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.hotel &&
                                  _vm.hotel.additional_fees &&
                                  !_vm.hotel.additional_fees.length
                                    ? _c("div", [
                                        _vm._v(
                                          "The hotel has no additional fees/taxes to applied to this reservation"
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.hotel &&
                                  _vm.hotel.additional_fees &&
                                  _vm.hotel.additional_fees.length
                                    ? _c("div", [
                                        _vm._v(
                                          "The hotel has the following fees which may be applied to this reservation:"
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.hotel
                                    ? _c(
                                        "ol",
                                        _vm._l(
                                          _vm.hotel.additional_fees,
                                          function (additionalFee) {
                                            return _c("li", [
                                              _vm._v(
                                                "\n                                                " +
                                                  _vm._s(
                                                    additionalFee.fee_type.name
                                                  ) +
                                                  " (" +
                                                  _vm._s(additionalFee.name) +
                                                  ") - " +
                                                  _vm._s(
                                                    additionalFee.description
                                                  ) +
                                                  " \n                                            "
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm.quote
                                ? _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "2" } },
                                    [_vm._v("Quote")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.quote
                                ? _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "10" } },
                                    [
                                      _c(
                                        "fieldset",
                                        [
                                          _c(
                                            "v-layout",
                                            { attrs: { wrap: "" } },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: { cols: "6", md: "2" },
                                                },
                                                [_vm._v("Rate Total:")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "6",
                                                    md: "10",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.quote.ratesTotal
                                                    ) +
                                                      " (" +
                                                      _vm._s(
                                                        _vm.quote.reasons
                                                          .room_rates
                                                      ) +
                                                      ")"
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: { cols: "6", md: "2" },
                                                },
                                                [_vm._v("Tax/Fees Total:")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "6",
                                                    md: "10",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.quote.taxTotal) +
                                                      " (" +
                                                      _vm._s(
                                                        _vm.quote.reasons.taxes
                                                          ? _vm.quote.reasons
                                                              .taxes
                                                          : "No taxes/fees applied"
                                                      ) +
                                                      ")"
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: { cols: "6", md: "2" },
                                                },
                                                [_vm._v("Grand Total:")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "6",
                                                    md: "10",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.quote.grandTotal
                                                    ) +
                                                      " (" +
                                                      _vm._s(
                                                        _vm.quote.reasons
                                                          .grand_total
                                                      ) +
                                                      ")"
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: { cols: "6", md: "2" },
                                                },
                                                [_vm._v("Commission Amount:")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "6",
                                                    md: "10",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.quote.commission
                                                    ) +
                                                      " (" +
                                                      _vm._s(
                                                        _vm.quote.reasons
                                                          .commission
                                                      ) +
                                                      ")"
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: { cols: "6", md: "2" },
                                                },
                                                [_vm._v("Deposit:")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "6",
                                                    md: "10",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.quote.deposit) +
                                                      " (" +
                                                      _vm._s(
                                                        _vm.quote.reasons
                                                          .room_rates
                                                      ) +
                                                      ")"
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: { cols: "6", md: "2" },
                                                },
                                                [_vm._v("Is Advance Payment?:")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "6",
                                                    md: "10",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.quote.isAdvancePayment
                                                        ? "Yes"
                                                        : "No"
                                                    ) +
                                                      " (" +
                                                      _vm._s(
                                                        _vm.quote.reasons
                                                          .advance_payment
                                                      ) +
                                                      ")"
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                                _vm._v("Notes"),
                              ]),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "12", md: "10" } }, [
                                _c("fieldset", [
                                  _c("textarea", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.reservation.internal_notes,
                                        expression:
                                          "reservation.internal_notes",
                                      },
                                    ],
                                    domProps: {
                                      value: _vm.reservation.internal_notes,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.reservation,
                                          "internal_notes",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "ies-green",
                                      on: {
                                        click: function ($event) {
                                          return _vm.getQuote()
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", [_vm._v("quote")]),
                                      _vm._v(" Get Quote"),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      directives: [
                                        {
                                          name: "disabled",
                                          rawName: "v-disabled",
                                          value: _vm.quote !== null,
                                          expression: "quote !== null",
                                        },
                                      ],
                                      staticClass: "ies-green",
                                      on: {
                                        click: function ($event) {
                                          return _vm.createNewReservation()
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", [_vm._v("save")]),
                                      _vm._v(" Create"),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }